import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./style.css";

const FloatingMenu = () => {
  const [tipoUsuario, setTipoUsuario] = useState(localStorage.getItem("tempTipo")); // chefe | cobrador | vendedor
  const navigate = useNavigate();

  useEffect(() => {
    setTipoUsuario(localStorage.getItem("tempTipo"));     
  }, []);

  function sair() {
    localStorage.clear();
    navigate("/");
  }

  return (
    <div className="floating-menu">

      {/* INÍCIO */}
      <NavLink
        to="/home"
        className={({ isActive }) =>
          isActive ? "menu-item active" : "menu-item"
        }
      >
        <i className="fas fa-home"></i>
        <span>Início</span>
      </NavLink>

      {/* COBRANÇA */}
      {(tipoUsuario === "E" || tipoUsuario === "C") && (
        <NavLink
          to="/cobranca"
          className={({ isActive }) =>
            isActive ? "menu-item active" : "menu-item"
          }
        >
          <i className="fas fa-file-invoice-dollar"></i>
          <span>Cobrança</span>
        </NavLink>
      )}

      {/* VENDA */}
      {(tipoUsuario === "V" || tipoUsuario === "C" || tipoUsuario === "E") && (
        <NavLink
          to="/venda"
          className={({ isActive }) =>
            isActive ? "menu-item active" : "menu-item"
          }
        >
          <i className="fas fa-shopping-cart"></i>
          <span>Venda</span>
        </NavLink>
      )}

      {/* ESTOQUE */}
      {(tipoUsuario === "E" || tipoUsuario === "V") && (
        <NavLink
          to="/estoque"
          className={({ isActive }) =>
            isActive ? "menu-item active" : "menu-item"
          }
        >
          <i className="fas fa-boxes"></i>
          <span>Estoque</span>
        </NavLink>
      )}

      {/* SAIR */}

      <NavLink
          to="/"
          onClick={sair}
          className={({ isActive }) =>
            isActive ? "menu-item active" : "menu-item"
          }
        >
          <i className="fas fa-sign-out-alt"></i>
          <span>Sair</span>
        </NavLink>      
    </div>
  );
};

export default FloatingMenu;
